export { searchKbs } from './kbs';
